export const creditnotes = {
  alerts: {
    missingFcFiles_one: 'Le PDF de cette note de crédit est introuvable.',
    missingFcFiles_other: 'Les PDF de ces notes de crédit sont introuvables.',
    successCreated: 'Votre note de crédit a été créée.',
  },
  breadcrumb: {
    create: 'Créer une note de crédit',
    overview: 'Notes de crédit',
  },
  create: {
    blocker: 'Voulez-vous vraiment quitter cette page ? Votre note de crédit n’a pas été enregistrée.',
    confirmation: {
      description:
        'Voulez-vous vraiment créer la note de crédit ? Une fois la note de crédit approuvée et envoyée à votre client, vous ne pourrez plus la modifier.',
      sentWithPeppol: 'Après approbation, votre note de crédit sera envoyée via Peppol.',
      submit: 'Oui, créer la note de crédit',
      title: 'Votre note de crédit nous est envoyée',
    },
    error: {
      title: 'Erreur lors du chargement de la note de crédit.',
    },
    partialPaymentsWarning: {
      message_one:
        'Nous avons déjà reçu un paiement partiel de {{ payment }} pour cette facture. N’hésitez pas à créditer la facture, nous assurerons avec vous le suivi de ce paiement.',
      message_other:
        'Nous avons déjà reçu des paiements partiels de {{ payment }} pour cette facture. N’hésitez pas à créditer la facture, nous assurerons avec vous le suivi de ces paiements.',
      title: 'Petite info !',
    },
    submit: 'Créer la note de crédit',
    title: 'Nouvelle note de crédit',
  },
  fields: {
    invoiceId: {
      label: 'Note de crédit pour la facture',
      placeholder: 'Sélectionnez une facture',
    },
    numberingSeriesId: {
      helpText: 'Le numéro de la note de crédit sera <0>{{entryNumber}}</0>.',
      tooltip:
        'Ceci est un aperçu du numéro de votre note de crédit. Le numéro ne devient définitif qu’au moment où vous nous envoyez la note de crédit.',
    },
    reason: {
      helpText: 'Attention : le motif est visible sur la note de crédit envoyée à votre client.',
      label: 'Motif',
      placeholder: 'Saisissez votre motif ici',
    },
  },
  overview: {
    columns: {
      client: 'Client',
      date: 'Date',
      entryNumber: 'Note de crédit',
      reason: 'Motif',
      status: {
        options: {
          Approved: 'Approuvée',
          InReview: 'En attente d’approbation',
        },
        sentWithPeppolTooltip: 'via Peppol',
        title: 'Statut',
      },
      total: 'Crédité',
    },
    created: {
      subtitle: 'Notes de crédit',
    },
    error: {
      title: 'Erreur lors du chargement de vos notes de crédit.',
    },
    rowActions: {
      download: 'Télécharger',
    },
  },
};
